/**
 * Initial mail count compiled at build time
 * This ensures the page loads with a number immediately (no loading state)
 */

// Import the build-time generated mail count
import mailCountData from './mailCount.json'

/**
 * Get initial mail count from build-time data
 * This is fetched from the API at build time and compiled into the bundle
 */
export function getInitialMailCount(): number {
  return mailCountData.count
}

// Export the initial count as a constant for immediate access
export const INITIAL_MAIL_COUNT = mailCountData.count

// Export build metadata for debugging
export const MAIL_COUNT_BUILD_TIME = mailCountData.buildTime
export const MAIL_COUNT_SOURCE = mailCountData.source

/**
 * Format mail count with locale-specific thousands separator
 */
export function formatMailCount(count: number): string {
  return count.toLocaleString('en-GB')
}